// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1bua9","footer":"styles_footer__bB5DM"};